import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/pro-solid-svg-icons';

import AddControl from 'components/add_control/v2';
import RemindersFields from 'bundles/apex/reminders/reminders_fields';
import Section from './section';

import type { Deal } from 'bundles/apex/deals/types';
import type { Reminder } from 'bundles/apex/reminders/types';
import type { TaskFormState } from 'bundles/apex/tasks/types';

interface Props {
  dateNameWhitelist?: string[];
  deal?: Deal;
  fields?: any;
  reminders: Reminder[];
  task: TaskFormState;
  onChange: (reminders: Partial<Reminder>[], autosave?: boolean) => void;
}

export default function TaskRemindersFields({
  deal,
  fields,
  task,
  reminders = [],
  onChange,
  ...props
}: Props) {
  const handleAdd = () => {
    onChange([...reminders, { sendOn: undefined }]);
  };

  return (
    <React.Fragment>
      <Section label="Reminders">
        <AddControl label="Add Reminder" onClick={handleAdd} />
      </Section>
      <div className="form form-horizontal">
        <RemindersFields
          dateNameWhitelist={['taskName']}
          deal={{ ...deal, taskName: task.deadline }}
          fields={{
            ...fields,
            taskName: { label: task.name || 'task', isDate: true },
          }}
          label={<FontAwesomeIcon icon={faCalendar} />}
          reminders={reminders}
          showAddControl={false}
          onChange={reminders => onChange(reminders, true)}
          {...props}
        />
      </div>
    </React.Fragment>
  );
}
